require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./brand-design-north-american-properties.json") })
        }
      }, "path---brand-design-north-american-properties");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---brand-design-north-american-properties!./.cache/json/brand-design-north-american-properties.json
// module id = 378
// module chunks = 231608221292675